import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { Product } from '../../../shared/models';
import { ProductModuleState } from '../../models/product.model';
import * as actions from '../actions/product.actions';

function selectIdNumber(c: Product): number {
  return c.id;
}
export const adapter: EntityAdapter<Product> = createEntityAdapter<Product>({
  selectId: selectIdNumber,
});

export const initialState = <ProductModuleState>{
  products: adapter.getInitialState([]),
  isLoaded: false,
};

const productReducer = createReducer(
  initialState,
  on(actions.clearProductState, (state) => ({
    ...state,
    isLoaded: false,
    products: adapter.removeAll(state.products),
  })),
  on(actions.loadProductsSuccess, (state, { products }) => ({
    ...state,
    isLoaded: true,
    products: adapter.setAll(products, state.products),
  })),
  on(actions.setSelectedProductSuccess, (state, { product }) => ({
    ...state,
    selectedProduct: product,
  })),
  on(actions.getProductsSuccess, (state, { products }) => ({
    ...state,
    isLoaded: true,
    products: adapter.setAll(products, state.products),
  })),
  on(actions.deleteProductSuccess, (state, { productId }) => ({
    ...state,
    selectedProduct: undefined as Product,
    products: adapter.removeOne(productId, state.products),
  })),
  on(actions.loadSelectedCountrySuccess, (state, { id }) => ({
    ...state,
    selectedCountry: id,
  })),
  on(actions.setSelectedCountrySuccess, (state, { id, products }) => ({
    ...state,
    selectedCountry: id,
    products: adapter.setAll(products, state.products),
  })),
);

export function reducer(state: ProductModuleState | undefined, action: Action) {
  return productReducer(state, action);
}
